export default __webpack_public_path__ + "static/1868-ddb28d72907e5e28cf7e882745dc2a78.gif";